import { useState } from 'react';

export const useSteps = (init: number) => {
    const [current, setCurrent] = useState(init);

    const next = () => setCurrent(current + 1);
    const prev = () => setCurrent(current - 1);

    return { current, next, prev };
};